import { IconProps } from '.';

const YoutubeIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 27 27"
      fill="none"
      className={customClasses}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_8792_15003)">
        <path
          d="M26.241 7.79922C26.241 7.79922 25.9871 6.00664 25.2051 5.21953C24.2148 4.18359 23.1078 4.17852 22.6 4.11758C18.9641 3.85352 13.5051 3.85352 13.5051 3.85352H13.4949C13.4949 3.85352 8.03594 3.85352 4.4 4.11758C3.89219 4.17852 2.78516 4.18359 1.79492 5.21953C1.01289 6.00664 0.764062 7.79922 0.764062 7.79922C0.764062 7.79922 0.5 9.90664 0.5 12.009V13.9793C0.5 16.0816 0.758984 18.1891 0.758984 18.1891C0.758984 18.1891 1.01289 19.9816 1.78984 20.7688C2.78008 21.8047 4.08008 21.7691 4.65898 21.8809C6.74102 22.0789 13.5 22.1398 13.5 22.1398C13.5 22.1398 18.9641 22.1297 22.6 21.8707C23.1078 21.8098 24.2148 21.8047 25.2051 20.7688C25.9871 19.9816 26.241 18.1891 26.241 18.1891C26.241 18.1891 26.5 16.0867 26.5 13.9793V12.009C26.5 9.90664 26.241 7.79922 26.241 7.79922ZM10.8137 16.3711V9.06367L17.8367 12.7301L10.8137 16.3711Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_8792_15003">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default YoutubeIcon;
